import './Institucional.css'
import Header from '../../componentes/js/Header';
import Footer from '../../componentes/js/Footer';
import {useState, useEffect} from 'react';

const Institucional = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [expandido, setExpandido] = useState({});

    const toggleExpand = (id) => {
      setExpandido(prev => ({
        ...prev,
        [id]: !prev[id]
      }));
    };
    
    const depos = [
      `Tenho uma história de muitos anos com o colégio e só tenho motivos para agradecer. Minha filha estudou nele por alguns anos, 
      concluiu o ensino médio e hoje já está se formando em Nutrição. Meu filho mais novo está terminando o 3º ano, e acompanhar o 
      crescimento e o desenvolvimento deles ao longo desse tempo me enche de orgulho.
      O ensino é de altíssima qualidade, os professores são extremamente dedicados e comprometidos com o aprendizado. A coordenadora 
      Giselle, a Marcella e o Blayth são sempre atenciosos e presentes, o que faz toda a diferença. Além deles, cada funcionário tem um 
      papel especial, desde as recepcionistas, sempre gentis e prestativas, até o querido tio Líder, que recebe os alunos na entrada com 
      uma energia contagiante que já começa o dia deixando todos mais animados.
      O colégio vai muito além de ensinar conteúdos, ele acolhe, incentiva e ajuda a formar cidadãos. Sou muito grata por tudo que ele 
      representou na vida dos meus filhos. E fico sentida por esse ciclo estar se finalizando. Sentiremos falta do colégio Líder, com 
      toda certeza!`,
      `O Colégio Líder fez parte da vida das nossas filhas por 7 anos, e nossa família sente uma imensa gratidão por tudo o que 
      vivenciaram ali. Foram anos de aprendizado, crescimento e acolhimento, em um ambiente que sempre cuidou com carinho e dedicação. 
      Levaremos para sempre no coração os valores, as memórias e todo o carinho recebido ao longo dessa caminhada.`,
      `Minha filha estuda no Colégio Líder desde os 3 aninhos de idade, pois a época havia a Educação Infantil. Hoje minha filha já está 
      no 8º ano do Ensino Fundamental e estou extremamente satisfeita com a qualidade do ensino e o ambiente acolhedor que a escola proporciona.
      O corpo docente é, sem dúvida, o grande diferencial. Os professores são dedicados, não apenas transmitindo o conteúdo de forma excelente, 
      mas também inspirando os alunos terem curiosidade e paixão por aprender. 
      Além do desempenho acadêmico, o que mais me encanta é o foco da escola no desenvolvimento integral de cada aluno, oferecendo um 
      ambiente que estimula a criatividade, o respeito, a responsabilidade, o pensamento e prepara os estudantes não só para a faculdade, 
      mas para a vida.
      Recomendamos o Colégio Líder sem reservas a qualquer família que busque uma educação de excelência, respeito e carinho para seus 
      filhos. Parabéns a toda a equipe!`,
      `Meus filhos estudam no Colégio Líder há 5 anos e continuarão até o final do ensino médio. A escola conta com profissionais altamente 
      capacitados que atuam de forma exemplar nas áreas social e educacional promovendo o desenvolvimento socioemocional dos alunos. Desde cedo, 
      os estudantes recebem preparação completa para o enem e vestibulares. Na entrada do ensino médio, consigo perceber, pelos estudos da minha 
      filha, que está no 1º ano do ensino médio a atenção personalizada que a escola oferece as suas necessidades. O Colégio Líder é sem dúvida, 
      uma excelente escolha para quem busca educação de qualidade!`
    ]
  
  
    useEffect(() => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
      if (/android/i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent)) {
        setIsMobile(true);
      }
  
      const elementosAnimados = document.querySelectorAll('.elemento-animado, .elemento-animado-esquerda, .elemento-animado-direita, .elemento-animado-down');
  
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('entrou-na-tela');
          }
        });
      }, { threshold: 0.4 });
  
      elementosAnimados.forEach(elemento => {
        observer.observe(elemento);
      });
  
      return () => {
        elementosAnimados.forEach(elemento => {
          observer.unobserve(elemento);
        });
      };
    }, []);
    
  const renderTexto = (id, texto, limite) => {
    if (!isMobile) return texto;

    const textoCortado = texto.substring(0, limite) + "...";
    const isExpandido = expandido[id];

    return (
      <>
        {isExpandido ? texto : textoCortado}
        <button 
          className="verMais"
          onClick={() => toggleExpand(id)}
          style={{ marginBottom: 10 }}
        >
          {isExpandido ? "Ver Menos" : "Ver Mais"}
        </button>
      </>
    );
  };

  return (
    <div style={{backgroundImage: 'url(assets/images/fundo/fundo2.png)', backgroundSize: isMobile ? '60%' : '25%', backgroundPosition: 'center', backgroundRepeat: 'repeat', marginBottom: '-16vh'}}>
      <Header />
      <main>
          <div className="sobrenos-container" style={{flexDirection: isMobile ? 'column' : 'row'}}>
          <div>
            <img style={{ width: isMobile ? '50%' : 'auto', height: 'auto' }} src='assets/images/selo.png' alt="Selo Colégio Líder" />
          </div>
        <div className='conteudo'>
          <div>
            <div className="fundo">
              <h1 style={{color: 'black'}}>Apresentação do nosso colégio</h1>
            </div>
            <p style={{padding: isMobile ? '0 10px' : '0'}}>
              O Colégio Líder é mais do que uma escola, é um projeto de vida para os seus alunos. Aqui, nós oferecemos uma educação de excelência, 
              baseada em valores éticos, humanos e sociais, que contribuem para a formação integral dos nossos estudantes. 
            </p>
            <p style={{padding: isMobile ? '0 10px' : '0'}}>
              Nossos alunos do Ensino Fundamental e do Ensino Médio são estimulados a descobrir seus talentos, suas paixões, suas vocações e suas 
              missões. Eles aprendem a pensar criticamente, a agir com autonomia, a assumir responsabilidades e a criar soluções inovadoras.
            </p>  
            <p style={{padding: isMobile ? '0 10px' : '0'}}>
              Nossa equipe pedagógica é formada por profissionais competentes e dedicados, que acompanham de perto o desenvolvimento de cada 
              aluno, respeitando suas individualidades e potencializando suas capacidades. Venha conhecer o Colégio Líder, uma escola que 
              transforma vidas!
            </p>
          </div>
        </div>
      </div>

      <div className='depoimentos'>
          <div className="depoimento">
              <div className='imagemDepoimento'>
                  <img src='assets/images/depoimentos/mae.jpg' alt='Foto da mãe da Maria Eduarda Marques'/>
              </div>
              <p className='textDepo'>
                {renderTexto("depo3", depos[2], 120)}
              </p>
              <h3>Mamãe da Maria Eduarda Marques</h3>
          </div>
          <div className="depoimento">
              <div className='imagemDepoimento'>
                  <img src='assets/images/depoimentos/cintya.jpg' alt='Foto da mãe da Maria Julia e Ana Luísa'/>
              </div>
              <p className='textDepo'>
                {renderTexto("depo2", depos[1], 120)}
              </p>
              <h3>Mamãe da Maria Julia e Ana Luísa</h3>
          </div>
          <div className="depoimento">
              <div className='imagemDepoimento'>
                  <img src='assets/images/depoimentos/kelly.jpg' alt='Foto da mãe do João Guilherme'/>
              </div>
              <p className='textDepo'>
                {renderTexto("depo1", depos[0], 120)}
              </p>
              <h3>Mamãe do João Guilherme</h3>
          </div>
          <div className="depoimento">
              <div className='imagemDepoimento'>
                  <img src='assets/images/depoimentos/lino.jpg' alt='Foto da mãe da Ana Julia e Mateus Lino'/>
              </div>
              <p className='textDepo'>
                {renderTexto("depo4", depos[3], 120)}
              </p>
              <h3>Mamãe da Ana Julia e Mateus Lino</h3>
          </div>
      </div>

      <div className="grid-container elemento-animado-direita" style={{marginBottom: 30 + "px"}}>
        <div className="grid-item elemento-animado-direita">
          <div className="imagem">
            <img src="assets/images/proposta-pedagogica.jpg" alt="Proposta Pedagógica"/>
          </div>
          <div className="texto">
            <h1>Proposta Pedagógica</h1>
            <hr className="amarelo"/>
            <p>
              O Colégio Líder oferece o Ensino Fundamental e o Ensino Médio, 
              apoiado no desenvolvimento de uma consciência crítica, na autonomia, 
              responsabilidade e criatividade para uma boa execução do processo ensino-aprendizagem, 
              e ainda, busca dar direcionamento à prática educativa, visando à formação integral 
              dos alunos, em seus aspectos físicos, intelectuais e emocionais.
            </p>
          </div>  
        </div>
      </div>

      </main>
      <Footer />
    </div>
  );
};

export default Institucional;
